module.exports = __webpack_public_path__ + "img/testimonial-amy-lechner.483b187c.png";